import {bannerActionTypes} from "../constants/ActionTypes";

const initialState = {
  banner: null,
  validationErrors: null
};

const banner = (state = initialState, action) => {
  switch (action.type) {

    case bannerActionTypes.GET_BANNER:
      return {
        ...state,
        banner: action.banner,
      };

    case bannerActionTypes.SET_BANNER_ELEMENT:
      const newState = {
        ...state,
        banner: {
          ...state.banner,
          banner_elements: [].concat(state.banner.banner_elements)
        },
        validation: null
      };

      if (action.banner_element.id) {
        const index = newState.banner.banner_elements.findIndex(element => element.id === action.banner_element.id);
        if (index !== -1) {
          newState.banner.banner_elements[index] = action.banner_element;
        }
      } else {
        newState.banner.banner_elements.push(action.banner_element);
      }

      return newState;

    case bannerActionTypes.DELETE_BANNER_ELEMENT:
      const elements = [].concat(state.banner.banner_elements);
      elements.splice(state.banner.banner_elements.findIndex(el => el.id === action.elementId), 1);

      return {
        ...state,
        banner: {
          ...state.banner,
          banner_elements: elements
        }
      };

    case bannerActionTypes.SET_ELEMENTS_ORDER:
      return {
        ...state,
        banner: {
          ...state.banner,
          banner_elements: action.elements
        }
      };

    case bannerActionTypes.CHANGE_FILE:
      const bannerElements = [].concat(state.banner.banner_elements);
      let blockToChangeImg = bannerElements[action.index];
      blockToChangeImg.img_src_desktop = action.img_src_desktop;
      bannerElements[action.index] = blockToChangeImg;

      return {
        ...state,
        banner: {
          ...state.banner,
          banner_elements: bannerElements
        }
      };

  }

  return state;
};

export default banner;



// WEBPACK FOOTER //
// ./reducers/banner.reducers.js